import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
import { useMediaQuery, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import logo from "../img/logo.png";
import ImageList from "@mui/material/ImageListItem";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import Axios from "axios";
import { useDispatch } from "react-redux";
import { logout } from "../../src/store/userSilce";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type": {
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const styles = {
  paperContainer: {
    backgroundImage: `url(${logo})`,
    height: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "blur(8px)",
  },

  textblur: {
    backgroundColor: "rgba(255, 255, 255,0.9)",
    position: "absolute",
    width: "100%",
  },
};
function PagePrintTableScoreMobile() {
  const styles = {
    paperContainer: {
      backgroundImage: `url(${logo})`,
      height: "100%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      filter: "blur(8px)",
    },

    textblur: {
      backgroundColor: "rgba(255, 255, 255,0.9)",
      position: "absolute",
      width: "100%",
    },
  };
  const componentRef = useRef();
  //   const location = useLocation();
  //   const queryParams = new URLSearchParams(location.search);
  //   const encodedData = queryParams.get('data');
  //   const decodedString = decodeURIComponent(encodedData);
  //   const decodedArray = JSON.parse(decodedString);
  //   const testxxx = `https://englishtest.rtaf.mi.th/PagePrintTableTestListScoreMobile?data=${encodedData}`;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  // const { user } = useSelector((state) => ({ ...state }));
  // const token = user.token;
  const isLargeScreen = useMediaQuery("(min-width: 1200px)"); // lg
  const isMediumScreen = useMediaQuery(
    "(min-width: 960px) and (max-width: 1199px)"
  ); // md
  const isSmallScreen = useMediaQuery(
    "(min-width: 600px) and (max-width: 959px)"
  ); // sm
  const isExtraSmallScreen = useMediaQuery("(max-width: 599px)"); // xs
  // const { countRole1 ,countRole2,countRole3,countRole4,countRole5,calculateMean1,calculateMean2,calculateMean3,calculateMean4,calculateMean5,max1,max2,max3,max4,max5,min1,min2,min3,min4,min5,allScoresmax,allScoresmin,selectAllList,testreqdate,realscoredate,filteredData,date,lastTwoChars} = useParams();
  const [selectAllList, setSelectAllList] = useState([]);
  const [testresultapprv, Settestresultapprv] = useState("");
 


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedData = queryParams.get("data");
  // const decodedString = decodeURIComponent(encodedData);
  const Dataperson = location.state.Dataperson
  const decodedData = decodeURIComponent(escape(atob(Dataperson)));
  const parsedData = JSON.parse(decodedData);
  // const decodedArray = JSON.parse(decodedString);
  const testxxx = `https://englishtest.rtaf.mi.th/PagePrintTableScoreMobile?data=${encodedData}`;
  // const token = location.state.token
  // const data = location.state.data
  const token = parsedData.token
  const data = parsedData.data
  // console.log("data",data)
  // console.log("token",token)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = {
          method: "GET",
          url:
            process.env.REACT_APP_API_URL +
            `/getalldataContentPageListTestScoresDivision/${data.testrequnit}/${data.testreqdate}`,
          headers: {
            authtoken: "bearer " + token,
          },
        };
        const res = await Axios(config);
        setSelectAllList(res.data);
        Settestresultapprv(res.data[0]?.testresultapprv || "");
        // console.log("data :", res.data);
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 404) {
          dispatch(logout());
          navigate("/notfound404", {
            state: { statusCode: err.response.status, txt: err.response.data },
          });
        } else {
          console.error("getPubrelContents: ", err);
        }
      }
    };

    fetchData();
  }, [data.testrequnit, data.testreqdate, token, dispatch, navigate]);

  const filteredArrayIncludes = selectAllList.filter((item) =>
    item.testindvappvcode?.includes("APR")
  );
  // const filteredData = filteredArrayIncludes.filter(
  //   (item) => item.testresvcode === data.testresvcode
  // );
  const filteredData = filteredArrayIncludes.filter(
    (item) => item.testresvcode === data.testresvcode
  );
  const filteredDataNoTest = filteredData.filter(
    (item) => item["testconductdate"] !== null
  );

  
  const countRole1 = () => {
    let counter = 0;

    filteredDataNoTest.forEach((item) => {
      if (
        item["tbmemberinfo.mem_rank"] === "น.ต." ||
        item["tbmemberinfo.mem_rank"] === "น.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ต." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "น.ท." ||
        item["tbmemberinfo.mem_rank"] === "น.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ท." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "น.อ." ||
        item["tbmemberinfo.mem_rank"] === "น.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "น.อ.(พ)" ||
        item["tbmemberinfo.mem_rank"] === "น.อ.หญิง(พ)" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.อ." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ น.อ.หญิง"
      ) {
        counter++;
      }
    });

    return counter;
  };

  const countRole2 = () => {
    let counter = 0;

    filteredDataNoTest.forEach((item) => {
      if (
        item["tbmemberinfo.mem_rank"] === "ร.ต." ||
        item["tbmemberinfo.mem_rank"] === "ร.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ต." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ร.ท." ||
        item["tbmemberinfo.mem_rank"] === "ร.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ท." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ร.อ." ||
        item["tbmemberinfo.mem_rank"] === "ร.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.อ." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "กห.ส.(ช)" ||
        item["tbmemberinfo.mem_rank"] === "กห.ส.(ญ)" 
      ) {
        counter++;
      }
    });

    return counter;
  };

  const countRole3 = () => {
    let counter = 0;

    filteredDataNoTest.forEach((item) => {
      if (
        item["tbmemberinfo.mem_rank"] === "พ.อ.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.อ." ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.อ.หญิง(พ)" ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.อ.(พ)" ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.ท." ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "พ.อ.ต."
      ) {
        counter++;
      }
    });

    return counter;
  };

  const countRole4 = () => {
    let counter = 0;

    filteredDataNoTest.forEach((item) => {
      if (
        item["tbmemberinfo.mem_rank"] === "จ.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "จ.อ." ||
        item["tbmemberinfo.mem_rank"] === "จ.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "จ.ท." ||
        item["tbmemberinfo.mem_rank"] === "จ.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "จ.ต." ||
        item["tbmemberinfo.mem_rank"] === "กห.ป.(ช)" ||
        item["tbmemberinfo.mem_rank"] === "กห.ป.(ญ)" 
      ) {
        counter++;
      }
    });

    return counter;
  };

  const countRole5 = () => {
    let counter = 0;

    filteredDataNoTest.forEach((item) => {
      if (
        item["tbmemberinfo.mem_rank"] === "นางสาว" ||
        item["tbmemberinfo.mem_rank"] === "นาง" ||
        item["tbmemberinfo.mem_rank"] === "นาย" ||
        item["tbmemberinfo.mem_rank"] === "ไม่ระบุ"
      ) {
        counter++;
      }
    });

    return counter;
  };

  const filteredData1 = filteredDataNoTest.filter(
    (item) =>
      item["tbmemberinfo.mem_rank"] === "น.ต." ||
    item["tbmemberinfo.mem_rank"] === "น.ต.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ต." ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ต.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "น.ท." ||
    item["tbmemberinfo.mem_rank"] === "น.ท.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ท." ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.ท.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "น.อ." ||
    item["tbmemberinfo.mem_rank"] === "น.อ.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "น.อ.(พ)" ||
    item["tbmemberinfo.mem_rank"] === "น.อ.หญิง(พ)" ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.อ." ||
    item["tbmemberinfo.mem_rank"] === "ว่าที่ น.อ.หญิง"
  );
  const renderData1 = () => {
    // เช็กก่อนว่า editscore ทั้งหมดเป็น null
    const isAllEditScoreNull = filteredData1.every(
     (item) => item["editscore"] === null
   );
 
   const renderedItems = [];
 
   for (let i = 0; i < filteredData1.length; i++) {
     if (isAllEditScoreNull) {
       renderedItems.push(filteredData1[i]["realscore"]);
     } else {
       renderedItems.push(filteredData1[i]["editscore"]);
     }
   }
 
   return renderedItems;
   // const renderedItems = [];
   // for (let i = 0; i < filteredData1.length; i++) {
   //   renderedItems.push(filteredData1[i]["editscore"]);
   // }

   // return renderedItems;
 };

  const calculateMean1 = () => {
    let sum = 0;
    filteredData1.forEach((item) => {
      item["editscore"] === null || item["editscore"] === 0
        ? (sum += item["realscore"])
        : (sum += item["editscore"]);
    });

    const mean = sum / filteredData1.length;
    return mean.toFixed(2) === "NaN" ? 0 : Number(mean.toFixed(2));
  };

  function findMode1(arr) {
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    arr.forEach(function (obj) {
      let val =
        obj.editscore !== null && obj.editscore !== 0
          ? obj.editscore
          : obj.realscore;

      if (!modeMap[val]) modeMap[val] = 0;
      modeMap[val]++;

      if (modeMap[val] > maxCount) {
        modes = [val];
        maxCount = modeMap[val];
      } else if (modeMap[val] === maxCount) {
        modes.push(val);
      }
    });

    return modes[0] >= 0 && modes[0] <= 26
      ? "A1"
      : modes[0] >= 27 && modes[0] <= 47
      ? "A2"
      : modes[0] >= 48 && modes[0] <= 77
      ? "B1"
      : modes[0] >= 78 && modes[0] <= 89
      ? "B2"
      : modes[0] >= 90 && modes[0] <= 100
      ? "C1"
      : "-";
  }

  const modes1 = findMode1(filteredData1);

  const filteredData2 = filteredDataNoTest.filter(
    (item) =>
      item["tbmemberinfo.mem_rank"] === "ร.ต." ||
        item["tbmemberinfo.mem_rank"] === "ร.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ต." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ต.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ร.ท." ||
        item["tbmemberinfo.mem_rank"] === "ร.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ท." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.ท.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ร.อ." ||
        item["tbmemberinfo.mem_rank"] === "ร.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.อ." ||
        item["tbmemberinfo.mem_rank"] === "ว่าที่ ร.อ.หญิง" ||
        item["tbmemberinfo.mem_rank"] === "กห.ส.(ช)" ||
        item["tbmemberinfo.mem_rank"] === "กห.ส.(ญ)" 
  );

  const renderData2 = () => {
    // เช็กก่อนว่า editscore ทั้งหมดเป็น null
    const isAllEditScoreNull = filteredData2.every(
     (item) => item["editscore"] === null
   );
 
   const renderedItems = [];
 
   for (let i = 0; i < filteredData2.length; i++) {
     if (isAllEditScoreNull) {
       renderedItems.push(filteredData2[i]["realscore"]);
     } else {
       renderedItems.push(filteredData2[i]["editscore"]);
     }
   }
 
   return renderedItems;
   // const renderedItems = [];
   // for (let i = 0; i < filteredData2.length; i++) {
   //   renderedItems.push(filteredData2[i]["editscore"]);
   // }

   // return renderedItems;
 };

  const calculateMean2 = () => {
    let sum = 0;
    filteredData2.forEach((item) => {
      item["editscore"] === null || item["editscore"] === 0
        ? (sum += item["realscore"])
        : (sum += item["editscore"]);
    });

    const mean = sum / filteredData2.length;
    return mean.toFixed(2) === "NaN" ? 0 : Number(mean.toFixed(2));
  };

  function findMode2(arr) {
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    arr.forEach(function (obj) {
      let val =
        obj.editscore !== null && obj.editscore !== 0
          ? obj.editscore
          : obj.realscore;

      if (!modeMap[val]) modeMap[val] = 0;
      modeMap[val]++;

      if (modeMap[val] > maxCount) {
        modes = [val];
        maxCount = modeMap[val];
      } else if (modeMap[val] === maxCount) {
        modes.push(val);
      }
    });

    return modes[0] >= 0 && modes[0] <= 26
      ? "A1"
      : modes[0] >= 27 && modes[0] <= 47
      ? "A2"
      : modes[0] >= 48 && modes[0] <= 77
      ? "B1"
      : modes[0] >= 78 && modes[0] <= 89
      ? "B2"
      : modes[0] >= 90 && modes[0] <= 100
      ? "C1"
      : "-";
  }

  const modes2 = findMode2(filteredData2);

  const filteredData3 = filteredDataNoTest.filter(
    (item) =>
      item["tbmemberinfo.mem_rank"] === "พ.อ.อ.หญิง" ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.อ." ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.อ.หญิง(พ)" ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.อ.(พ)" ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.ท.หญิง" ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.ท." ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.ต.หญิง" ||
      item["tbmemberinfo.mem_rank"] === "พ.อ.ต."
  );


  const renderData3 = () => {
    // เช็กก่อนว่า editscore ทั้งหมดเป็น null
    const isAllEditScoreNull = filteredData3.every(
      (item) => item["editscore"] === null
    );
  
    const renderedItems = [];
  
    for (let i = 0; i < filteredData3.length; i++) {
      if (isAllEditScoreNull) {
        renderedItems.push(filteredData3[i]["realscore"]);
      } else {
        renderedItems.push(filteredData3[i]["editscore"]);
      }
    }
  
    return renderedItems;
  };

  const calculateMean3 = () => {
    let sum = 0;
    filteredData3.forEach((item) => {
      item["editscore"] === null || item["editscore"] === 0
        ? (sum += item["realscore"])
        : (sum += item["editscore"]);
    });

    const mean = sum / filteredData3.length;
    return mean.toFixed(2) === "NaN" ? 0 : Number(mean.toFixed(2));
  };

  function findMode3(arr) {
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    arr.forEach(function (obj) {
      let val =
        obj.editscore !== null && obj.editscore !== 0
          ? obj.editscore
          : obj.realscore;

      if (!modeMap[val]) modeMap[val] = 0;
      modeMap[val]++;

      if (modeMap[val] > maxCount) {
        modes = [val];
        maxCount = modeMap[val];
      } else if (modeMap[val] === maxCount) {
        modes.push(val);
      }
    });

    return modes[0] >= 0 && modes[0] <= 26
      ? "A1"
      : modes[0] >= 27 && modes[0] <= 47
      ? "A2"
      : modes[0] >= 48 && modes[0] <= 77
      ? "B1"
      : modes[0] >= 78 && modes[0] <= 89
      ? "B2"
      : modes[0] >= 90 && modes[0] <= 100
      ? "C1"
      : "-";
  }

  const modes3 = findMode3(filteredData3);

  const filteredData4 = filteredDataNoTest.filter(
    (item) =>
      item["tbmemberinfo.mem_rank"] === "จ.อ.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "จ.อ." ||
    item["tbmemberinfo.mem_rank"] === "จ.ท.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "จ.ท." ||
    item["tbmemberinfo.mem_rank"] === "จ.ต.หญิง" ||
    item["tbmemberinfo.mem_rank"] === "จ.ต." ||
    item["tbmemberinfo.mem_rank"] === "กห.ป.(ช)" ||
    item["tbmemberinfo.mem_rank"] === "กห.ป.(ญ)" 
  );

  const renderData4 = () => {
    const isAllEditScoreNull = filteredData4.every(
      (item) => item["editscore"] === null
    );
  
    const renderedItems = [];
  
    for (let i = 0; i < filteredData4.length; i++) {
      if (isAllEditScoreNull) {
        renderedItems.push(filteredData4[i]["realscore"]);
      } else {
        renderedItems.push(filteredData4[i]["editscore"]);
      }
    }
  
    return renderedItems;
    // const renderedItems = [];
    // for (let i = 0; i < filteredData4.length; i++) {
    //   renderedItems.push(filteredData4[i]["editscore"]);
    // }

    // return renderedItems;
  };

  const calculateMean4 = () => {
    let sum = 0;
    filteredData4.forEach((item) => {
      item["editscore"] === null || item["editscore"] === 0
        ? (sum += item["realscore"])
        : (sum += item["editscore"]); // sum += item["editscore"];
    });

    const mean = sum / filteredData4.length;
    return mean.toFixed(2) === "NaN" ? 0 : Number(mean.toFixed(2));
  };


  const filteredData5 = filteredDataNoTest.filter(
    (item) =>
      item["tbmemberinfo.mem_rank"] === "ไม่ระบุ" ||
      item["tbmemberinfo.mem_rank"] === "นางสาว" ||
      item["tbmemberinfo.mem_rank"] === "นาง" ||
      item["tbmemberinfo.mem_rank"] === "นาย"
  );

  // function findMode4(arr) {
  //   let modeMap = {};
  //   let maxCount = 0;
  //   let modes = [];

  //   arr.forEach(function (obj) {
  //     let val =
  //       obj.realscore !== null && obj.realscore !== 0
  //         ? obj.realscore
  //         : obj.editscore;

  //     if (!modeMap[val]) modeMap[val] = 0;
  //     modeMap[val]++;

  //     if (modeMap[val] > maxCount) {
  //       modes = [val];
  //       maxCount = modeMap[val];
  //     } else if (modeMap[val] === maxCount) {
  //       modes.push(val);
  //     }
  //   });
  function findMode4(arr) {
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    arr.forEach(function (obj) {
      let val =
        obj.editscore !== null && obj.editscore !== 0
          ? obj.editscore
          : obj.realscore;

      if (!modeMap[val]) modeMap[val] = 0;
      modeMap[val]++;

      if (modeMap[val] > maxCount) {
        modes = [val];
        maxCount = modeMap[val];
      } else if (modeMap[val] === maxCount) {
        modes.push(val);
      }
    });

    return modes[0] >= 0 && modes[0] <= 26
      ? "A1"
      : modes[0] >= 27 && modes[0] <= 47
      ? "A2"
      : modes[0] >= 48 && modes[0] <= 77
      ? "B1"
      : modes[0] >= 78 && modes[0] <= 89
      ? "B2"
      : modes[0] >= 90 && modes[0] <= 100
      ? "C1"
      : "-";
  }

  const modes4 = findMode4(filteredData4);

  const renderData5 = () => {
    const isAllEditScoreNull = filteredData5.every(
      (item) => item["editscore"] === null
    );
  
    const renderedItems = [];
  
    for (let i = 0; i < filteredData5.length; i++) {
      if (isAllEditScoreNull) {
        renderedItems.push(filteredData5[i]["realscore"]);
      } else {
        renderedItems.push(filteredData5[i]["editscore"]);
      }
    }
  
    return renderedItems;
   
  };

  const calculateMean5 = () => {
    let sum = 0;
    filteredData5.forEach((item) => {
      item["editscore"] === null || item["editscore"] === 0
        ? (sum += item["realscore"])
        : (sum += item["editscore"]);
    });

    const mean = sum / filteredData5.length;
    return mean.toFixed(2) === "NaN" ? 0 : Number(mean.toFixed(2));
  };

  function findMode5(arr) {
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    arr.forEach(function (obj) {
      let val =
        obj.editscore !== null && obj.editscore !== 0
          ? obj.editscore
          : obj.realscore;

      if (!modeMap[val]) modeMap[val] = 0;
      modeMap[val]++;

      if (modeMap[val] > maxCount) {
        modes = [val];
        maxCount = modeMap[val];
      } else if (modeMap[val] === maxCount) {
        modes.push(val);
      }
    });

    return modes[0] >= 0 && modes[0] <= 26
      ? "A1"
      : modes[0] >= 27 && modes[0] <= 47
      ? "A2"
      : modes[0] >= 48 && modes[0] <= 77
      ? "B1"
      : modes[0] >= 78 && modes[0] <= 89
      ? "B2"
      : modes[0] >= 90 && modes[0] <= 100
      ? "C1"
      : "-";
  }

  const modes5 = findMode5(filteredData5);

  const summode = [modes1, modes2, modes3, modes4, modes5];

  function findModesum(arr) {
    let filteredArr = arr.filter((value) => value !== "-"); // กรองออกค่าว่าง
    let modeMap = {};
    let maxCount = 0;
    let modes = [];

    filteredArr.forEach(function (value) {
      if (!modeMap[value]) modeMap[value] = 0;
      modeMap[value]++;

      if (modeMap[value] > maxCount) {
        modes = [value];
        maxCount = modeMap[value];
      } else if (modeMap[value] === maxCount) {
        modes.push(value);
      }
    });

    return modes;
  }

  const modessum = findModesum(summode);

  const maxScores1 =
    Math.max.apply(Math, renderData1()) === -Infinity
      ? 0
      : Math.max.apply(Math, renderData1());
  const maxScores2 =
    Math.max.apply(Math, renderData2()) === -Infinity
      ? 0
      : Math.max.apply(Math, renderData2());
  const maxScores3 =
    Math.max.apply(Math, renderData3()) === -Infinity
      ? 0
      : Math.max.apply(Math, renderData3());
  const maxScores4 =
    Math.max.apply(Math, renderData4()) === -Infinity
      ? 0
      : Math.max.apply(Math, renderData4());
  const maxScores5 =
    Math.max.apply(Math, renderData5()) === -Infinity
      ? 0
      : Math.max.apply(Math, renderData5());
      const minScores1 =
      Math.min.apply(Math, renderData1()) === Infinity
        ? 0
        : Math.min.apply(Math, renderData1());
    const minScores2 =
      Math.min.apply(Math, renderData2()) === Infinity
        ? 0
        : Math.min.apply(Math, renderData2());
    const minScores3 =
      Math.min.apply(Math, renderData3()) === Infinity
        ? 0
        : Math.min.apply(Math, renderData3());
    const minScores4 =
      Math.min.apply(Math, renderData4()) === Infinity
        ? 0
        : Math.min.apply(Math, renderData4());
    const minScores5 =
      Math.min.apply(Math, renderData5()) === Infinity
        ? 0
        : Math.min.apply(Math, renderData5());
      const allScoresmax = [
        maxScores1,
        maxScores2,
        maxScores3,
        maxScores4,
        maxScores5,
      ];
  const allScoresmin = [
    minScores1,
    minScores2,
    minScores3,
    minScores4,
    minScores5,
  ];
  const nonZeroNumbers = allScoresmin.filter((number) => number !== 0);
  const allScoresMax =
    Math.max.apply(Math, allScoresmax) === -Infinity
      ? 0
      : Math.max.apply(Math, allScoresmax);
  const allScoresMin =
    Math.min.apply(Math, nonZeroNumbers) === Infinity
      ? 0
      : Math.min.apply(Math, nonZeroNumbers);
  const date = moment(data.testreqdate)
    .add(543, "year")
    .format("DD MMMYY");
  const lastTwoChars = date.slice(-2);

  const mean =
    (calculateMean1 +
      calculateMean2 +
      calculateMean3 +
      calculateMean4 +
      calculateMean5) /
    (countRole1 + countRole2 + countRole3 + countRole4 + countRole5);
 

    const values = [
      calculateMean1(),
      calculateMean2(),
      calculateMean3(),
      calculateMean4(),
      calculateMean5()
    ];
    
    // กรองค่าที่ไม่เป็นศูนย์
    const nonZeroValues = values.filter(value => value !== 0);
    
    // คำนวณค่าเฉลี่ยจากค่าที่ไม่เป็นศูนย์
    const means = nonZeroValues.reduce((sum, value) => sum + value, 0) / nonZeroValues.length;
    return (
    <>
      <Box style={styles.paperContainer}></Box>
      <Box
        style={styles.textblur}
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "fixed",
          // background:'#000000'
          // width: "740px"
        }}
        // ref={componentRef}
        ref={componentRef}
      >
        <Box
          sx={{
            width: "100%",
            zIndex: "3",
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",

            // marginTop: "15px",
            height: { lg: "100%", md: "100%", sm: "100%", xs: "100%" },
          }}
        >
          <TableContainer
            sx={{
              // backgroundColor: " rgba(255, 255, 255, 0.9)",
              width: { lg: "1280px", md: "1280px", sm: "350px", xs: "350px" },
              // height: { lg: "1280px", md: "1280px", sm: "350px", xs: "350px" },
              display: "flex",
              borderWidth: "1px",
              borderColor: "#000000",
              marginTop: "100px",
              justifyContent: "center",
            }}
            //  sx={{
            //    backgroundColor: " rgba(255, 255, 255, 0.9)",
            //    width: "800px",
            //    height: "100%",
            //    display: "flex",
            //    borderWidth: "1px",
            //    borderColor: "#000000",
            //  }}
            // ref={componentRef}
          >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow sx={{ border: "2px solid black" }}>
                  <TableCell align="center" colSpan={7}>
                    <Box
                      sx={{
                        width: {
                          lg: "1200px",
                          md: "1200px",
                          sm: "300px",
                          xs: "300px",
                        },
                        height: {
                          lg: "150px",
                          md: "150px",
                          sm: "35px",
                          xs: "35px",
                        },
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      //  sx={{
                      //    width: "750px",
                      //    height: "80px",
                      //    display: "flex",
                      //  }}
                    >
                      <Box>
                        <ImageList
                          //  sx={{ width: 80, height: 50, padding: 2 }}
                          sx={{
                            width: {
                              lg: "120px",
                              md: "120px",
                              sm: "50px",
                              xs: "50px",
                            },
                            height: {
                              lg: "120px",
                              md: "120px",
                              sm: "50px",
                              xs: "50px",
                            },
                            paddingRight: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img src={logo} alt="logo" />
                        </ImageList>
                      </Box>
                      <Box>
                        <Box>
                          <Typography
                            //  variant="subtitle1"
                            component="div"
                            //  sx={{ color: "#2F5597", fontWeight: "bold" }}
                            sx={{
                              color: "#2F5597",
                              fontWeight: "bold",
                              fontSize: {
                                lg: "16px",
                                md: "16px",
                                sm: "6px",
                                xs: "6px",
                              },
                            }}
                          >
                            ศูนย์ภาษา กรมยุทธศึกษาทหารอากาศ
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: {
                              lg: "800px",
                              md: "800px",
                              sm: "220px",
                              xs: "220px",
                            },
                            height: {
                              lg: "80px",
                              md: "80px",
                              sm: "20px",
                              xs: "20px",
                            },
                            backgroundColor: "#2F5597",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                          }}
                          //  sx={{
                          //    width: "600px",
                          //    height: "40px",
                          //    backgroundColor: "#2F5597",
                          //    display: "flex",
                          //    justifyContent: "center",
                          //    alignItems: "center",
                          //    flexDirection: "column",
                          //  }}
                        >
                          <Typography
                            //  variant="body2"
                            component="div"
                            //  sx={{ color: "#ffffff", fontSize: "12px" }}
                            sx={{
                              color: "#ffffff",
                              fontSize: {
                                lg: "12px",
                                md: "12px",
                                sm: "6px",
                                xs: "6px",
                              },
                            }}
                          >
                            รายงานผลคะแนนการทดสอบภาษาอังกฤษ
                          </Typography>
                          <Typography
                            //  variant="body2"
                            component="div"
                            //  sx={{ color: "#ffffff", fontSize: "12px" }}
                            sx={{
                              color: "#ffffff",
                              fontSize: {
                                lg: "12px",
                                md: "12px",
                                sm: "6px",
                                xs: "6px",
                              },
                            }}
                          >
                            แยกตามรายการทดสอบ และสังกัด
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          width: {
                            lg: "160px",
                            md: "160px",
                            sm: "60px",
                            xs: "60px",
                          },
                          height: {
                            lg: "160px",
                            md: "160px",
                            sm: "60px",
                            xs: "60px",
                          },
                          display: "flex",
                          flexDirection: "column",
                          paddingLeft: {
                            lg: "50px",
                            md: "50px",
                            sm: "10px",
                            xs: "10px",
                          },
                          paddingTop: {
                            lg: "0px",
                            md: "0px",
                            sm: "5px",
                            xs: "5px",
                          },
                          // padding: 2,
                        }}
                      >
                        {isSmallScreen || isExtraSmallScreen ? (
                          <>
                            <QRCodeCanvas
                              value={testxxx}
                              size={40}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                              includeMargin={false}
                              imageSettings={{
                                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSciNW49eY224gsT55faql5f-AaKfOyeoj9gQ&usqp=CAU",
                                x: undefined,
                                y: undefined,
                                height: 8,
                                width: 8,
                                excavate: true,
                              }}
                            />
                            <Box
                              sx={{
                                width: {
                                  lg: "160px",
                                  md: "60px",
                                  sm: "40px",
                                  xs: "40px",
                                },
                                height: {
                                  lg: "160px",
                                  md: "60px",
                                  sm: "10px",
                                  xs: "10px",
                                },
                                backgroundColor: "#000000",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                // variant="body2"
                                component="div"
                                sx={{
                                  color: "#ffffff",
                                  fontSize: {
                                    lg: "12px",
                                    md: "12px",
                                    sm: "6px",
                                    xs: "6px",
                                  },
                                }}
                              >
                                Verifyed
                              </Typography>
                            </Box>
                          </>
                        ) : (
                          <>
                            <QRCodeCanvas
                              value={testxxx}
                              size={140}
                              bgColor={"#ffffff"}
                              fgColor={"#000000"}
                              level={"L"}
                              includeMargin={false}
                              imageSettings={{
                                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSciNW49eY224gsT55faql5f-AaKfOyeoj9gQ&usqp=CAU",
                                x: undefined,
                                y: undefined,
                                height: 10,
                                width: 10,
                                excavate: true,
                              }}
                            />
                            <Box
                              sx={{
                                width: {
                                  lg: "140px",
                                  md: "140px",
                                  sm: "40px",
                                  xs: "40px",
                                },
                                height: {
                                  lg: "60px",
                                  md: "60px",
                                  sm: "10px",
                                  xs: "10px",
                                },
                                backgroundColor: "#000000",
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                // variant="body2"
                                component="div"
                                sx={{
                                  color: "#ffffff",
                                  fontSize: {
                                    lg: "12px",
                                    md: "12px",
                                    sm: "6px",
                                    xs: "6px",
                                  },
                                }}
                              >
                                Verifyed
                              </Typography>
                            </Box>
                          </>
                        )}
                      </Box>
                      {/* <Box>
                     <ImageList
                       sx={{ width: 80, height: 50, padding: 2 }}
                     >
                       <img src={qrcode} alt="logo" />
                     </ImageList>
                   </Box> */}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ border: "2px solid black" }}>
                  <TableCell align="center" colSpan={7}>
                    <Typography
                      //  variant="body2"
                      component="div"
                      //  sx={{
                      //    color: "#000000",
                      //    fontSize: "10px",
                      //    fontWeight: "bold",
                      //  }}
                      sx={{
                        color: "#000000",
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        fontWeight: "bold",
                      }}
                    >
                      ผลการทดสอบวัดระดับความเข้าใจภาษาอังกฤษ
                    </Typography>

                    <Typography
                      //  variant="body2"
                      component="div"
                      //  sx={{
                      //    color: "#000000",
                      //    fontSize: "10px",
                      //    fontWeight: "bold",
                      //  }}
                      sx={{
                        color: "#000000",
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        fontWeight: "bold",
                      }}
                    >
                      รายการทดสอบ
                      โครงการทดสอบความสามารถในการใช้ภาษาอังกฤษของกำลังพล
                      ทอ.ประจำปี {lastTwoChars} สังกัด ศซว.ทอ.
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ border: "2px solid black" }}>
                  <TableCell
                    colSpan={1}
                    align="center"
                    // sx={{
                    //   color: "#000000",
                    //   fontWeight: "bold",
                    //   fontSize: "10px",
                    // }}
                    sx={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                    }}
                  >
                    ลำดับ
                  </TableCell>
                  <TableCell
                    align="center"
                    colSpan={1}
                    // sx={{
                    //   color: "#000000",
                    //   fontWeight: "bold",
                    //   fontSize: "10px",
                    // }}
                    sx={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                    }}
                  >
                    ยศ-ชื่อ-นามสกุล
                  </TableCell>
                  <TableCell
                    colSpan={1}
                    align="center"
                    // sx={{
                    //   color: "#000000",
                    //   fontWeight: "bold",
                    //   fontSize: "10px",
                    // }}
                    sx={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                    }}
                  >
                    สอบได้
                  </TableCell>
                  <TableCell
                    colSpan={1}
                    align="center"
                    // sx={{
                    //   color: "#000000",
                    //   fontWeight: "bold",
                    //   fontSize: "10px",
                    // }}
                    sx={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                    }}
                  >
                    ทดสอบเมื่อ
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    // sx={{
                    //   color: "#000000",
                    //   fontWeight: "bold",
                    //   fontSize: "10px",
                    // }}
                    sx={{
                      color: "#000000",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                    }}
                  >
                    หมายเหตุ
                  </TableCell>
                  {/* <TableCell
                        align="center"
                        // sx={{
                        //   color: "#000000",
                        //   fontWeight: "bold",
                        //   fontSize: "10px",
                        // }}
                        sx={{
                          color: "#000000",
                          fontWeight: "bold",
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                        }}
                      >
                        
                      </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDataNoTest.map((row, i) => (
                  <StyledTableRow
                    key={row["tbmember.tbmemberinfos.meminfo_id"]}
                    sx={{ border: "2px solid black" }}
                  >
                    <StyledTableCell align="center" colSpan={1}>
                      <Box
                        sx={{
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        {i + 1}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={1}>
                      <Box
                        sx={{
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {row["tbmemberinfo.mem_rank"] +
                          " " +
                          row["tbmemberinfo.mem_fname"] +
                          " " +
                          row["tbmemberinfo.mem_lname"]}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={1}>
                      <Box
                        sx={{
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {row["editscore"] === null || row["editscore"] === 0
                          ? row["realscore"]
                          : row["editscore"]}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={1}>
                      <Box
                        sx={{
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {row["realscoredate"] === null
                          ? "ยังไม่ได้ทำการทดสอบ"
                          : moment(row["realscoredate"])
                              .add(543, "year")
                              .format("DD MMMYY")}
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align="center" colSpan={3}>
                      <Box
                        sx={{
                          fontSize: {
                            lg: "12px",
                            md: "12px",
                            sm: "6px",
                            xs: "6px",
                          },
                          color: "#000000",
                          fontWeight: "bold",
                        }}
                      >
                        {Math.abs(
                          ((new Date(row["tbtestreservation.testreqdate"]) -
                            new Date(row["realscoredate"])) /
                            24) *
                            60 *
                            60 *
                            1000
                        ) === 0
                          ? row[
                              "tbtestreservation.tbtestscoringcriterium.mission"
                            ]
                          : "สอบวันสำรอง"}
                      </Box>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
              <TableRow sx={{ border: "2px solid black" }}>
                <TableCell align="center" colSpan={7} className="page-break">
                  <Typography
                    // variant="body2"
                    component="div"
                    // sx={{
                    //   color: "#000000",
                    //   fontSize: "10px",
                    //   fontWeight: "bold",
                    // }}
                    sx={{
                      color: "#000000",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    ค่าเฉลี่ยผลการทดสอบภาษาอังกฤษ
                  </Typography>

                  <Typography
                    // variant="body2"
                    component="div"
                    // sx={{
                    //   color: "#000000",
                    //   fontSize: "10px",
                    //   fontWeight: "bold",
                    // }}
                    sx={{
                      color: "#000000",
                      fontSize: {
                        lg: "12px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    รายการทดสอบ
                    โครงการทดสอบความสามารถในการใช้ภาษาอังกฤษของกำลังพล
                    ทอ.ประจำปี {lastTwoChars}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow sx={{ border: "2px solid black" }}>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  ชั้นยศ
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  จำนวนผู้เข้ารับการทดสอบ
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  ฐานนิยม
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  ค่าเฉลี่ย
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  คะแนนสูงสุด
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  คะแนนต่ำสุด
                </TableCell>
                <TableCell
                  align="center"
                  // sx={{
                  //   color: "#000000",
                  //   fontWeight: "bold",
                  //   fontSize: "10px",
                  // }}
                  sx={{
                    color: "#000000",
                    fontSize: {
                      lg: "12px",
                      md: "12px",
                      sm: "6px",
                      xs: "6px",
                    },
                    fontWeight: "bold",
                  }}
                >
                  หมายเหตุ
                </TableCell>
              </TableRow>
              <TableBody>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      น.ต.-น.อ.
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole1()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {modes1}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {calculateMean1()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {maxScores1}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {minScores1}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      ร.ต.-ร.อ.
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole2()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {modes2}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {calculateMean2()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {maxScores2}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {minScores2}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      พ.อ.ต.-พ.อ.อ.
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole3()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {modes3}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {calculateMean3()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {maxScores3}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {minScores3}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      จ.ต.-จ.อ.
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole4()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {modes4}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {calculateMean4()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {maxScores4}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {minScores4}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      พนักงานราชการและลูกจ้าง
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole5()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {modes5}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {calculateMean5()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {maxScores5}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {minScores5}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow sx={{ border: "2px solid black" }}>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      รวม
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {countRole1() +
                        countRole2() +
                        countRole3() +
                        countRole4() +
                        countRole5()}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                     {/* {modessum ?  Number(modessum).toFixed(2) : '-'} */}
                     {/* {isNaN(Number(modessum)) || modessum === null || modessum === undefined 
    ? '-' 
    : Number(modessum).toFixed(2)} */}
     {Array.isArray(modessum) && modessum.length > 0
                        ? modessum.join(", ") // แปลง array เป็น string โดยคั่นด้วย comma
                        : "-"}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {/* {(calculateMean1() +
                          calculateMean2() +
                          calculateMean3() +
                          calculateMean4() +
                          calculateMean5()) /
                          (countRole1() +
                            countRole2() +
                            countRole3() +
                            countRole4() +
                            countRole5() )} */}
                      {/* {isNaN(mean) ? "-" : mean} */}

                      {isNaN(
                    (calculateMean1() +
                      calculateMean2() +
                      calculateMean3() +
                      calculateMean4() +
                      calculateMean5()) /
                      (countRole1() +
                        countRole2() +
                        countRole3() +
                        countRole4() +
                        countRole5())
                  )
                    ? 0
                    : means.toFixed(2)
                    // : parseFloat(
                    //     (calculateMean1() +
                    //       calculateMean2() +
                    //       calculateMean3() +
                    //       calculateMean4() +
                    //       calculateMean5()) /
                    //       (countRole1() +
                    //         countRole2() +
                    //         countRole3() +
                    //         countRole4() +
                    //         countRole5())
                    //   ).toFixed(2)
                      
                      }

                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {allScoresMax}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" align="center">
                    <Box
                      sx={{
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                        color: "#000000",
                        fontWeight: "bold",
                      }}
                    >
                      {allScoresMin}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                  ></StyledTableCell>
                </StyledTableRow>
              </TableBody>
              <TableRow sx={{ border: "2px solid black" }}>
                <TableCell align="center" colSpan={7}>
                  <Box
                    sx={{
                      // width: "750px",
                      width: {
                        lg: "1200px",
                        md: "1200px",
                        sm: "300px",
                        xs: "300px",
                      },
                      // height: {
                      //   lg: "150px",
                      //   md: "150px",
                      //   sm: "35px",
                      //   xs: "35px",
                      // },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      // sx={{ color: "#2F5597", fontSize: "10px" }}
                      sx={{
                        color: "#2F5597",
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                      }}
                    >
                      เอกสารนี้เป็นเอกสารทางราชการผู้ที่ปลอมแปลงเอกสาร
                      มีโทษตามกฏหมาย
                    </Typography>
                    <Typography
                      variant="body2"
                      component="div"
                      // sx={{ color: "#2F5597", fontSize: "10px" }}
                      sx={{
                        color: "#2F5597",
                        fontSize: {
                          lg: "12px",
                          md: "12px",
                          sm: "6px",
                          xs: "6px",
                        },
                      }}
                    >
                      หากมีข้อสงสัยติดต่อ แผนกแผนการศึกษา ศูนย์ภาษา ยศ.ทอ.
                      โทร.02-534-2965
                    </Typography>
                    {/* {
                          filteredArrayIncludes.map((row, i) => (
                            <Typography
                            variant="body2"
                            component="div"
                            // sx={{ color: "#2F5597", fontSize: "10px" }}
                            sx={{ color: "#2F5597", fontSize: {
                              lg: "12px",
                              md: "12px",
                              sm: "6px",
                              xs: "6px",
                            }}}
                          >
                            {row.testindvappvcode}
                          </Typography>
                          ))
                        } */}
                  </Box>
                </TableCell>
              </TableRow>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
}

export default PagePrintTableScoreMobile;
